<ng-container *ngFor="let item of items | keyvalue">
  <ng-container *ngFor="let innerItem of item.value | keyvalue">
    <ng-container
      *ngIf="ParticipantformService.currentEvent == innerItem.value.event_id"
      [formGroup]="participant"
    >
      <mat-form-field
        class="example-full-width"
        *ngIf="innerItem.value.header1"
      >
        <mat-label>{{ innerItem.value.header1 }}</mat-label>
        <input
          matInput
          placeholder="Type {{ innerItem.value.header1 }}"
          formControlName="participant_column1"
          autocomplete="off"
          aria-autocomplete="list"
        />
        <mat-hint align="start"
          ><strong
            >Type the participant's
            {{ innerItem.value.header1 | lowercase }}</strong
          >
        </mat-hint>
      </mat-form-field>

      <mat-form-field
        class="example-full-width"
        *ngIf="innerItem.value.header2"
      >
        <mat-label>{{ innerItem.value.header2 }}</mat-label>
        <input
          matInput
          placeholder="Type {{ innerItem.value.header2 }}"
          formControlName="participant_column2"
          autocomplete="off"
          aria-autocomplete="list"
        />
        <mat-hint align="start"
          ><strong
            >Type the participant's
            {{ innerItem.value.header2 | lowercase }}</strong
          >
        </mat-hint>
      </mat-form-field>

      <mat-form-field
        class="example-full-width"
        *ngIf="innerItem.value.header3"
      >
        <mat-label>{{ innerItem.value.header3 }}</mat-label>
        <input
          matInput
          placeholder="Type {{ innerItem.value.header3 }}"
          formControlName="participant_column3"
          autocomplete="off"
          aria-autocomplete="list"
        />
        <mat-hint align="start"
          ><strong
            >Type the participant's
            {{ innerItem.value.header3 | lowercase }}</strong
          >
        </mat-hint>
      </mat-form-field>

      <mat-form-field
        class="example-full-width"
        *ngIf="innerItem.value.header4"
      >
        <mat-label>{{ innerItem.value.header4 }}</mat-label>
        <input
          matInput
          placeholder="Type {{ innerItem.value.header4 }}"
          formControlName="participant_column4"
          autocomplete="off"
          aria-autocomplete="list"
        />
        <mat-hint align="start"
          ><strong
            >Type the participant's
            {{ innerItem.value.header4 | lowercase }}</strong
          >
        </mat-hint>
      </mat-form-field>

      <mat-form-field
        class="example-full-width"
        *ngIf="innerItem.value.header5"
      >
        <mat-label>{{ innerItem.value.header5 }}</mat-label>
        <input
          matInput
          placeholder="Type {{ innerItem.value.header5 }}"
          formControlName="participant_column5"
          autocomplete="off"
          aria-autocomplete="list"
        />
        <mat-hint align="start"
          ><strong
            >Type the participant's
            {{ innerItem.value.header5 | lowercase }}</strong
          >
        </mat-hint>
      </mat-form-field>

      <mat-form-field
        class="example-full-width"
        *ngIf="innerItem.value.header6"
      >
        <mat-label>{{ innerItem.value.header6 }}</mat-label>
        <input
          matInput
          placeholder="Type {{ innerItem.value.header6 }}"
          formControlName="participant_column6"
          autocomplete="off"
          aria-autocomplete="list"
        />
        <mat-hint align="start"
          ><strong
            >Type the participant's
            {{ innerItem.value.header6 | lowercase }}</strong
          >
        </mat-hint>
      </mat-form-field>

      <mat-form-field
        class="example-full-width"
        *ngIf="innerItem.value.header7"
      >
        <mat-label>{{ innerItem.value.header7 }}</mat-label>
        <input
          matInput
          placeholder="Type {{ innerItem.value.header7 }}"
          formControlName="participant_column7"
          autocomplete="off"
          aria-autocomplete="list"
        />
        <mat-hint align="start"
          ><strong
            >Type the participant's
            {{ innerItem.value.header7 | lowercase }}</strong
          >
        </mat-hint>
      </mat-form-field>

      <mat-form-field
        class="example-full-width"
        *ngIf="innerItem.value.header8"
      >
        <mat-label>{{ innerItem.value.header8 }}</mat-label>
        <input
          matInput
          placeholder="Type {{ innerItem.value.header8 }}"
          formControlName="participant_column8"
          autocomplete="off"
          aria-autocomplete="list"
        />
        <mat-hint align="start"
          ><strong
            >Type the participant's
            {{ innerItem.value.header8 | lowercase }}</strong
          >
        </mat-hint>
      </mat-form-field>

      <mat-form-field
        class="example-full-width"
        *ngIf="innerItem.value.header9"
      >
        <mat-label>{{ innerItem.value.header9 }}</mat-label>
        <input
          matInput
          placeholder="Type {{ innerItem.value.header9 }}"
          formControlName="participant_column9"
          autocomplete="off"
          aria-autocomplete="list"
        />
        <mat-hint align="start"
          ><strong
            >Type the participant's
            {{ innerItem.value.header9 | lowercase }}</strong
          >
        </mat-hint>
      </mat-form-field>

      <mat-form-field
        class="example-full-width"
        *ngIf="innerItem.value.header10"
      >
        <mat-label>{{ innerItem.value.header10 }}</mat-label>
        <input
          matInput
          placeholder="Type {{ innerItem.value.header10 }}"
          formControlName="participant_column10"
          autocomplete="off"
          aria-autocomplete="list"
        />
        <mat-hint align="start"
          ><strong
            >Type the participant's
            {{ innerItem.value.header10 | lowercase }}</strong
          >
        </mat-hint>
      </mat-form-field>
    </ng-container></ng-container
  >
</ng-container>
